// CONSTANTS are all caps.
const NS = 'RelatedProducts';
const CLS = 'relatedProducts';
const BLK = '.' + CLS + '-';
const PRODUCT_TYPE = {
	COLOR: 'color',
	COLOR_SIZE: 'colorsize',
	SIZE: 'size',
	GENERIC: 'generic',
};
const DATA_COLOR_SIZES = 'sizes';

// import mock from './mock.js';
import _ from 'lodash';
import {SelectBox} from '../../selectbox/js/selectbox';
import {QuantityInput} from '../../../widgets/quantityInput/js/quantityInput';
import * as Api from '../../../../global/js/api.js';
import * as cart from '../../../../global/js/cart.js';
import * as utils from '../../../../global/js/utils.js';
import * as checkout from '../../../../global/js/checkout';
import {EVENT_RELATED_UPDATE} from '../../../../global/js/constants';

export class RelatedProducts {
	constructor($el) {
		this.$el = $el;
		this.$blockQuery = $($el);
		this.state = {
			products: [],
			cartLink: this.$blockQuery.attr('data-cart-link'),
			itemCode: this.$blockQuery.attr('data-item-code'),
			addToBagEndpoint: this.$blockQuery.attr('data-add-to-bag-endpoint'),
			getCollectionEndpoint: this.$blockQuery.attr('data-get-collection-endpoint'),
			title: this.$blockQuery.attr('data-title'),
		};
	}

	init() {
		this.create();
		this.setRelatedProducts();

		return this;
	}

	onAfterScreenLoad(successCallback) {
		this._successCallback = successCallback;

		return this;
	}

	create() {
		this.$title = $(`<div class="relatedProducts__head-title">${this.state.title || ''}</div>`);
		this.$list = $(`<div class="relatedProducts__list"></div>`);
		this.$blockQuery.html([this.$title, this.$list]);
	}

	setRelatedProducts() {
		Api.getApi(`${this.state.getCollectionEndpoint}/${this.state.itemCode}`).then((res) => {
			if (res.result === 'SUCCESS' && res.response && res.response.length) {
				this.state.products = res.response;
				const relatedCollection = res.response.map((product) => {
					const productInStock = this.convertProduct(product);
					return productInStock ? this.createProduct(productInStock) : null;
				}).filter((item) => item);

				if (relatedCollection.length) {
					this.$list.html(relatedCollection);
					this.fireSuccess(true);
				} else {
					this.$blockQuery.hide();
					this.fireSuccess(false);
				}

				this.$blockQuery.removeClass('loading');
				let excludeAmountPromoFreeShipping = window.spendAmountProductShippingPromotion.ExcludedVariationCodes || [];
				let excludeQtyPromoFreeShipping = window.buyQuantityShippingPromotionInfo.ExcludedVariationCodes || [];
				res.response.forEach((prod) => {
					if (!_.isNull(prod.spendAmountShippingPromotionInfo) && prod.spendAmountShippingPromotionInfo.amountGetFreeShipping > 0) {
						let variantExcludes = prod.spendAmountShippingPromotionInfo.excludedVariationCodes || [];
						excludeAmountPromoFreeShipping = _.concat(excludeAmountPromoFreeShipping, variantExcludes);
					}
					if (!_.isNull(prod.buyQuantityShippingPromotionInfo) && prod.buyQuantityShippingPromotionInfo.quantityGetFreeShipping > 0) {
						let variantExcludes = prod.buyQuantityShippingPromotionInfo.excludedVariationCodes || [];
						excludeQtyPromoFreeShipping = _.concat(excludeQtyPromoFreeShipping, variantExcludes);
					}
				});
				window.spendAmountProductShippingPromotion.ExcludedVariationCodes = excludeAmountPromoFreeShipping;
				window.buyQuantityShippingPromotionInfo.ExcludedVariationCodes = excludeQtyPromoFreeShipping;
			} else {
				this.$blockQuery.hide();
				this.fireSuccess(false);
			}
		}).catch((error) => {
			this.$blockQuery.hide();
			this.state.error = error;
			this.fireSuccess(false);
		});
	}

	fireSuccess(data) {
		_.isFunction(this._successCallback) && this._successCallback(data);
	}

	convertProduct(product) {
		// Check product out of stock.
		const isInStock = product.variants.filter((variant) => !variant.isOutOfStock).length;
		if (isInStock) {
			// Refer variant
			if (product.sizes) {
				product.sizes.items = product.sizes.items.map((size) => {
					const variant = {
						variant: product.variants.find((variant) => variant.code === size.sku),
					};
					return _.merge(size, variant);
				});
			}

			if (product.colors) {
				product.colors.items = product.colors.items.map((color) => {
					const variant = {
						variant: product.variants.find((variant) => variant.code === color.sku),
					};
					return _.merge(color, variant);
				});
			}

			// Convert display price.
			if (product.type === PRODUCT_TYPE.GENERIC) {
				const price = product.variants && product.variants.length && product.variants[0].price ? product.variants[0].price : {};
				product.price = this.getPrice(price);
			} else {
				const maxPrice = _.maxBy(product.variants || [], (variant) => variant.isOutOfStock ? null : variant.price.salePrice.amount);
				const minPrice = _.minBy(product.variants || [], (variant) => variant.isOutOfStock ? null : variant.price.salePrice.amount);
				if (maxPrice && minPrice && maxPrice.price.salePrice.amount === minPrice.price.salePrice.amount) {
					product.price = this.formatPrice(maxPrice.price.salePrice.amount);
				} else if (maxPrice && minPrice) {
					product.price = this.formatPrice(minPrice.price.salePrice.amount) + ' - ' + this.formatPrice(maxPrice.price.salePrice.amount);
				}
			}

			return product;
		}

		return null;
	}

	createProduct(product) {
		const disabledSize = product.type === PRODUCT_TYPE.COLOR_SIZE ? 'disabled' : '';
		const disabledQuantity = product.type === PRODUCT_TYPE.GENERIC ? '' : 'disabled';
		const initSku = product.type === PRODUCT_TYPE.GENERIC ? product.variants[0].code : '';
		const imageUrl = product.images && product.images.length ? (product.images[0].thumb || '') : '';
		const badge = product.type === PRODUCT_TYPE.GENERIC ? this.getBadge(product.variants[0].price || {}) : '';
		const notCnC = product.type === PRODUCT_TYPE.GENERIC ? product.variants[0].isClickCollectNotAvailable : '';
		const auVendor = product.type === PRODUCT_TYPE.GENERIC ? product.variants[0].isAustralianVendor : '';
		const menuAlignmentColor = product.type === PRODUCT_TYPE.COLOR_SIZE ? 'dropdown-menu-right' : '';

		const $productItem = $(`
			<div class="relatedProducts__item ${product.type || ''}"
				data-sku="${initSku}"
				data-sale-availability="${product.saleAvailability || ''}"
				data-notClickCollect="${notCnC}"
				data-australianvendor="${auVendor}"
				>
				<div class="relatedProducts__infor">
					<div class="relatedProducts__image" style="background-image: url(${imageUrl})">
					</div>
					<div class="relatedProducts__title">${product.title || ''}</div>
					${badge ? `<div class="relatedProducts__badge d-none d-md-block d-lg-none d-xl-block">${badge}</div>` : ''}
					<div class="relatedProducts__price ml-auto">
						${product.price || ''}
						${badge ? `<div class="relatedProducts__badge d-block d-md-none d-lg-block d-xl-none">${badge}</div>` : ''}
					</div>
					<div class="relatedProducts__input">
						<div class="pdp-bundlesItem_quantity quantityInput related-input" data-wg="QuantityInput">
							<div class="icon minus btn-down disabled"></div>
							<input type="number" min="0" value="0" step="1">
							<div class="icon plus btn-up ${disabledQuantity}"></div>
						</div>
						<div class="label-only-instore">Only available In-Store</div>
					</div>
					<div class="d-none d-md-block d-lg-none d-xl-block">
						<div class="relatedProducts__add-to-cart">
							<button type="button" class="btn btn-add-to-cart">Add to cart</button>
						</div>
					</div>
				</div>
				<div class="relatedProducts__variants">
					<div class="relatedProducts__options">
						<div class="relatedProducts__colour">
							<section class="selectbox" data-blk="SelectBox" select-box="colour">
								<button class="btn dropdown-toggle d-flex align-items-center" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span class="selectbox-title text-left">Select a colour</span>
									<span class="icon-chevron-down"></span>
								</button>
								<div class="dropdown-menu m-0 p-0"></div>
							</section>
						</div>
						<div class="relatedProducts__size ${menuAlignmentColor}">
							<section class="selectbox" data-blk="SelectBox" select-box="size">
								<button ${disabledSize} class="btn dropdown-toggle d-flex align-items-center" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span class="selectbox-title text-left">Select a size</span>
									<span class="icon-chevron-down"></span>
								</button>
								<div class="dropdown-menu m-0 p-0 dropdown-menu-right">
								</div>
							</section>
						</div>
					</div>
					<div class="d-block d-md-none d-lg-block d-xl-none">
						<div class="relatedProducts__add-to-cart">
							<button type="button" class="btn btn-add-to-cart">Add to cart</button>
						</div>
					</div>
				</div>
			</div>
		`);

		const $colourSelectBox = $productItem.find('[select-box="colour"]');
		const $sizeSelectBox = $productItem.find('[select-box="size"]');
		const $quantityInput = $productItem.find('[data-wg="QuantityInput"]');
		const $quantityInputTarget = $quantityInput.find('input');
		const $quantityUp = $quantityInput.find('.btn-up');

		const dropdownItem = ({
			name = '',
			sku,
			variant,
			isOutOfStock,
			colorSwatch = '',
			isNotClickCollect = '',
			isAustralianVendor = '',
		}) => {
			return $(`
				<div
					class="dropdown-item"
					data-oos="${!!isOutOfStock}"
					data-name="${name}"
					data-sku="${sku}"
					data-price="${this.formatPrice(variant.price ? variant.price.salePrice.amount : '')}"
					data-value="${sku}"
					data-notclickcollect="${isNotClickCollect}"
					data-australianVendor="${isAustralianVendor}">
						<div class="content-item">
							<div class="item-description">${name}</div>
							<div class="item-badge">${this.getBadge(variant.price || {})}</div>
							<div class="item-price">${this.getPrice(variant.price || {})}</div>
							<div class="item-oos">OUT OF STOCK</div>
							${colorSwatch}
						</div>
					</div>
				`);
		};

		const updateDisplayAddCart = () => {
			const sku = $productItem.attr('data-sku');
			const quantity = parseInt($quantityInputTarget.val() || 0);

			if (sku && quantity) {
				$quantityUp.removeClass('disabled');
				$productItem.addClass('enable-add-cart');
			} else if (sku) {
				$quantityUp.removeClass('disabled');
				$productItem.removeClass('enable-add-cart');
			} else {
				$quantityUp.addClass('disabled');
				$productItem.removeClass('enable-add-cart');
				$quantityInputTarget.val(0);
			}

			checkout.closeNearbyStores();
			this.$blockQuery.trigger(EVENT_RELATED_UPDATE);
		};

		// Render colour dropdown.
		$colourSelectBox.find('.dropdown-menu').html(product.colors.items.map((colour) => {
			let colorSwatch = '';
			if (colour.imageUrl) {
				colorSwatch = `<div class="item-color-swatch" style="background-image: url('${colour.imageUrl}')"></div>`;
			} else if (colour.hexColour) {
				const style = utils.getColourSwatch(colour.hexColour);
				colorSwatch = `<div class="item-color-swatch" style="${style}"></div>`;
			} else if (colour.variantImageUrl) {
				colorSwatch = `<div class="item-color-swatch" style="background-image: url('${colour.variantImageUrl}')"></div>`;
			}

			return dropdownItem({
				name: colour.colourName,
				sku: colour.sku,
				variant: colour.variant,
				isOutOfStock: colour.isOutOfStock,
				colorSwatch,
				isNotClickCollect: colour.isClickCollectNotAvailable,
				isAustralianVendor: colour.isAustralianVendor,
			}).data(DATA_COLOR_SIZES, colour.sizes && colour.sizes.items ? colour.sizes.items : []);
		}));

		// Render size dropdown.
		$sizeSelectBox.find('.dropdown-menu').html(product.sizes.items.map((size) => dropdownItem({
			name: size.sizeDescription,
			sku: size.sku,
			variant: size.variant,
			isOutOfStock: size.isOutOfStock,
			isNotClickCollect: size.isClickCollectNotAvailable,
			isAustralianVendor: size.isAustralianVendor,
		})));

		new SelectBox($colourSelectBox[0])
			.init()
			.onChange(({sku, price, notclickcollect, australianvendor}, item) => {
				switch (product.type) {
					case PRODUCT_TYPE.COLOR:
						handleVariantSeleted(sku, price, notclickcollect, australianvendor);
						break;

					case PRODUCT_TYPE.COLOR_SIZE:
						handleColourOfColorSize(sku, item, notclickcollect);
						break;

					default:
						break;
				}
			});

		new SelectBox($sizeSelectBox[0])
			.init()
			.onChange(({sku, price, notclickcollect, australianvendor}) => handleVariantSeleted(sku, price, notclickcollect, australianvendor));

		new QuantityInput($quantityInput).init();
		$quantityInputTarget.on('change', function() {
			updateDisplayAddCart();
		});

		// Auto selected colour first.
		// if (product.type === PRODUCT_TYPE.COLOR_SIZE) {
		// 	const $colourFrist = $colourSelectBox.find('.dropdown-item:not([data-oos="true"])').first();
		// 	$colourFrist.length && $colourFrist.trigger('click');
		// }

		$productItem.on('click', '.btn-add-to-cart', () => {
			const code = $productItem.attr('data-sku');
			const quantity = parseInt($quantityInputTarget.val() || 0);
			utils.showLoading();
			cart.addToCart({
				endpoint: this.state.addToBagEndpoint,
				code,
				quantity,
				size: $sizeSelectBox.attr('data-name') || '',
				title: product.title || '',
				cartLink: this.state.cartLink || '#',
				prodImg: imageUrl,
				items: [],
				datalayerDataSource: product.dataLayerDataSource ? JSON.parse(product.dataLayerDataSource) : '',
				isBundles: false,
			}, utils.hideLoading, utils.hideLoading);
		}).on('click', '.relatedProducts__title, .relatedProducts__image', () => {
			const itemId = product.code;
			const productImage = product.images && product.images.length && product.images[0].zoom ? product.images[0].zoom : '';
			$('[data-blk="ProductQuickView"]').trigger('quickview.show', [{itemId, productImage}]);
		});

		function handleVariantSeleted(sku, price, isNotCnC, auVendor) {
			$productItem.attr('data-sku', sku);
			$productItem.find('.relatedProducts__price').html(price);
			$productItem.attr('data-notclickcollect', isNotCnC);
			$productItem.attr('data-australianVendor', auVendor);
			updateDisplayAddCart();
		}

		function handleColourOfColorSize(sku, item, isNotCnC) {
			$sizeSelectBox.find('.dropdown-item').hide();
			($(item).data(DATA_COLOR_SIZES) || []).forEach(({
				sku,
			}) => {
				$sizeSelectBox.find(`.dropdown-item[data-sku="${sku}"]`).show();
			});
			$sizeSelectBox.find('.text-left').text('Select a size');
			$sizeSelectBox.find('.dropdown-toggle').removeAttr('disabled');
			$sizeSelectBox.removeAttr('data-name', '').removeAttr('data-value');
			$productItem.attr('data-sku', '');
			updateDisplayAddCart();
		}

		return $productItem;
	}

	getBadge({
		isClearancePrice,
		isKnockDownPrice,
		isDiscountPrice,
		isPromotionPrice,
		discountCode,
		discountBadgeBgColour,
		saleCode
	}) {
		const badges = {
			clearance: () => '<div class="productItem-label productItem-label--clearance"><span>CLEARANCE</span></div>',
			knockDown: (discountCode) => {
				let badge = '';
				if (discountCode) {
					badge = `<div class="productItem-label productItem-label--sale mb-1"><span>${discountCode}</span></div>`;
				}
				badge += `<div class="productItem-label productItem-label--knockdown" style="${window.KNOCKDOWN_STYLING.CustomStyle}"><span>${window.KNOCKDOWN_STYLING.Badge}</span></div>`;
				return badge;
			},
			discount: (saleCode, style) => `<div class="productItem-label productItem-label--${style ? 'discount' : 'sale'}" style="${utils.css({ 'background-color': discountBadgeBgColour })}; ${style}"><span>${utils.getDiscountText(saleCode)}</span></div>`,
			hotPrice: () => '<div class="productItem-label productItem-label--new"><span>HOT PRICE</span></div>',
		};

		if (isClearancePrice && isDiscountPrice) {
			return badges.clearance() + badges.discount(discountCode, utils.getStyle(window.DISCOUNT_WITH_CLEARANCE_STYLE || {}));
		} else if (isClearancePrice) {
			return badges.clearance();
		} else if (isKnockDownPrice) {
			return badges.knockDown(discountCode);
		} else if (isDiscountPrice) {
			return badges.discount(saleCode);
		} else if (isPromotionPrice) {
			return badges.hotPrice();
		}

		return '';
	}

	getPrice({
		isClearancePrice,
		isKnockDownPrice,
		isDiscountPrice,
		isPromotionPrice,
		salePrice,
		listPrice,
	}) {
		const isImportant = isClearancePrice || isKnockDownPrice || isDiscountPrice || isPromotionPrice;
		const classPrice = isImportant ? '-discount' : '-original';
		let priceOld = '';
		if (isPromotionPrice && listPrice.amount > 0) {
			priceOld = `<div class="price-old"><del>${this.formatPrice(listPrice.amount)}</del></div>`;
		}

		const price = `<div class="price${classPrice}">${this.formatPrice(salePrice.amount)}</div>`;

		return priceOld + price;
	}

	formatPrice(price) {
		return `$${parseFloat(price).toFixed(2)}`;
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/relatedProducts/js/relatedProducts.js